import { normalizeDepartment } from './purchaseRequestAreas';

export const PURCHASE_REQUESTS_CHANGED_EVENT = 'sqmt-purchase-requests-changed';
export const PRODUCTION_PRODUCT_REQUESTS_CHANGED_EVENT = 'sqmt-production-product-requests-changed';

export const notifyPurchaseRequestsChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(PURCHASE_REQUESTS_CHANGED_EVENT));
};

export const notifyProductionProductRequestsChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(PRODUCTION_PRODUCT_REQUESTS_CHANGED_EVENT));
};

const upsellingMarker = (row) =>
  `${String(row?.justification || '')} ${String(row?.notes || '')}`.toLowerCase();

export const isCommercialUpsellingRequest = (row) => {
  const blob = upsellingMarker(row);
  if (!blob.includes('upselling')) return false;
  const dept = normalizeDepartment(row?.department).toLowerCase();
  // Origen comercial (actual) o registros previos con departamento Adquisiciones.
  return dept === 'comercial' || dept === 'adquisiciones' || blob.includes('cotización') || blob.includes('cotizacion');
};

/**
 * Cantidad de una solicitud: número de envases + formato tal como se cotizó
 * (p. ej. "5 Galón", "4 Tineta 16 L"). No convertir a litros: la cantidad ya
 * viene expresada en unidades de formato desde el ítem de la cotización.
 */
export const formatRequestQty = (quantity, unit) => {
  const qty = Number(quantity || 0);
  if (!qty) return '—';
  const formatted = qty.toLocaleString('es-CL', { maximumFractionDigits: 2 });
  const label = String(unit || '').trim();
  return label ? `${formatted} ${label}` : formatted;
};

export const formatRequestDateEs = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
};
